import React, { useState, useEffect, useRef, useMemo } from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_mgb-formations/artifacts/ds42szgw_Design%20MGB%20School%20%285%29.png";

// ===============================================================
// Catalogue spécifique au certificat — 25 formations avec
// noms et tarifs spécifiés par MGB School pour les attestations.
// ===============================================================
const CERT_FORMATIONS = [
  { name: "Analyse SWOT pour entrepreneurs", price: 79, content: "Matrice SWOT · Forces · Faiblesses · Opportunités · Menaces · Cas concrets · Quiz corrigé" },
  { name: "Marketing digital pour TPE", price: 97, content: "SEO · Réseaux sociaux · Google Ads · Canva · Stratégie de contenu · Analytics · Quiz corrigé" },
  { name: "Création d'activité e-commerce", price: 89, content: "Shopify · WooCommerce · Fiches produits · SEO e-commerce · Paiement en ligne · Quiz corrigé" },
  { name: "Gestion administrative microentreprise", price: 69, content: "Régime microentrepreneur · URSSAF · Déclarations · Seuils 2026 · Quiz corrigé" },
  { name: "Lecture et sécurisation contrat de travail", price: 149, content: "CDI · CDD · Clauses essentielles · Lecture guidée · Cas réels · Quiz corrigé" },
  { name: "Communication professionnelle numérique", price: 119, content: "Teams · Slack · E-mail pro · Visioconférence · LinkedIn · Quiz corrigé" },
  { name: "Gestion des stocks et logistique", price: 129, content: "ABC · FIFO · LIFO · Stock de sécurité · KPIs · Tableau de bord · Quiz corrigé" },
  { name: "Outils IA pour entreprises", price: 149, content: "ChatGPT · Claude · Prompting · Automatisation · Zapier · Make · Quiz corrigé" },
  { name: "Identifier les éléments clés d'un contrat", price: 79, content: "Mentions obligatoires · Clauses à risque · Non-concurrence · Mobilité · Quiz corrigé" },
  { name: "Comptabilité pour non-comptables", price: 97, content: "Bilan · Compte de résultat · SIG · Ratios financiers · Cas pratique · Quiz corrigé" },
  { name: "Bases de gestion pour créateurs", price: 89, content: "Prévisionnel · Seuil rentabilité · Trésorerie · Tableau de bord · Quiz corrigé" },
  { name: "Droit social pour TPE et PME", price: 69, content: "Obligations employeur · Congés · Rupture conventionnelle · Contrats · Quiz corrigé" },
  { name: "Maîtriser l'IA en entreprise", price: 149, content: "LLMs · Prompting avancé · IA générative · Automatisation · Cas entreprises · Quiz corrigé" },
  { name: "Créer son activité et business en ligne", price: 119, content: "Lean Canvas · Site web · Stripe · Premiers clients · Plan 30 jours · Quiz corrigé" },
  { name: "Communication digitale et réseaux sociaux", price: 129, content: "LinkedIn · Instagram · TikTok · Canva IA · Calendrier éditorial · KPIs · Quiz corrigé" },
  { name: "Pack Dissertation Management Stratégique", price: 990, content: "5 modules · 6 fiches auteurs · SWOT · PESTEL · Porter · 10 dissertations corrigées · 100 questions quiz · Méthodologie agrégation" },
  { name: "Maîtriser le Transport Routier", price: 79, content: "CMR · Réglementation · Temps de conduite · Tournées · Documents pro · Quiz corrigé" },
  { name: "Transport Maritime & Conteneurs", price: 97, content: "Conteneurs · Bill of Lading · Incoterms · Ports · Import/export · Quiz corrigé" },
  { name: "Transport Aérien de Marchandises", price: 89, content: "AWB · Poids taxable · Fret aérien · Sûreté · Cas export luxe · Quiz corrigé" },
  { name: "Organisation du Transport Ferroviaire", price: 69, content: "Rail · CIM · Transport combiné · Écologie · Coûts · Quiz corrigé" },
  { name: "Transport Multimodal & International", price: 149, content: "Chaîne logistique · Incoterms 2020 · Douane · Transit · Gestion risques · Quiz corrigé" },
  { name: "Supply Chain & Gestion Logistique Moderne", price: 119, content: "Stocks · WMS · TMS · KPIs · IA logistique · Tableau de bord · Quiz corrigé" },
  { name: "Douane, Incoterms & Documents Professionnels", price: 129, content: "DAU · EUR1 · Les 11 Incoterms 2020 · Documents export · TVA import · Quiz corrigé" },
  { name: "TMS, WMS & Outils Digitaux du Transport", price: 149, content: "TMS · WMS · ERP · KPIs transport · IA supply chain · Quiz corrigé" },
  { name: "Expert Transport & Logistique — Pack Complet", price: 299, content: "8 modules transport · Documents pro · 6 bonus · Simulations · Certificat · Quiz corrigé" },
];

// ===============================================================
// Chargement dynamique de html2pdf.js via CDN
// ===============================================================
const ensureHtml2Pdf = () => {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") return reject(new Error("no window"));
    if (window.html2pdf) return resolve(window.html2pdf);
    const existing = document.getElementById("html2pdf-script");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.html2pdf));
      existing.addEventListener("error", reject);
      return;
    }
    const s = document.createElement("script");
    s.id = "html2pdf-script";
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
    s.async = true;
    s.onload = () => resolve(window.html2pdf);
    s.onerror = reject;
    document.head.appendChild(s);
  });
};

const todayISO = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const formatDateFR = (iso) => {
  if (!iso) return "__ / __ / 2026";
  const [y, m, d] = iso.split("-");
  return `${d} / ${m} / ${y}`;
};

// ===============================================================
// Page Certificat — /certificat
// ===============================================================
const CertificatPage = () => {
  const [nom, setNom] = useState("Marie Dupont");
  const [formationIdx, setFormationIdx] = useState(0);
  const [dateISO, setDateISO] = useState(todayISO());
  const [resultat, setResultat] = useState("validee");
  const [score, setScore] = useState("");
  const [downloading, setDownloading] = useState(false);
  const certificateRef = useRef(null);

  const formation = useMemo(() => CERT_FORMATIONS[formationIdx], [formationIdx]);

  // Inject print styles once
  useEffect(() => {
    const id = "certificat-print-style";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      @media print {
        body * { visibility: hidden; }
        #certificat-printable, #certificat-printable * { visibility: visible; }
        #certificat-printable { position: absolute; left: 0; top: 0; width: 100%; }
        @page { size: A4 portrait; margin: 0; }
      }
    `;
    document.head.appendChild(style);
  }, []);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const html2pdf = await ensureHtml2Pdf();
      const safeName = (nom || "Apprenant").trim().replace(/\s+/g, "_").replace(/[^\w_-]/g, "");
      await html2pdf()
        .set({
          margin: 0,
          filename: `Certificat_MGB_School_${safeName}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true, allowTaint: false },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(certificateRef.current)
        .save();
    } catch (e) {
      // Fallback: native print
      window.print();
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="pt-20 md:pt-24 pb-32 md:pb-12 bg-[#F5F5F5] min-h-screen" data-testid="certificat-page">
      <div className="container-custom max-w-5xl">
        {/* Bandeau d'information — réservé aux apprenants ayant terminé leur formation */}
        <div
          className="rounded-xl p-4 md:p-5 mb-6 flex items-start gap-3"
          style={{
            backgroundColor: "#E3F2FD",
            borderLeft: "4px solid #2196F3",
          }}
          data-testid="certificat-access-banner"
        >
          <div
            className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold"
            style={{ backgroundColor: "#2196F3" }}
            aria-hidden="true"
          >
            ✓
          </div>
          <div className="text-sm md:text-base text-[#1A3A6E] leading-relaxed">
            <p className="font-bold mb-1">Espace certificat — Apprenants MGB School</p>
            <p className="text-[#1E293B]">
              Cette page est réservée aux apprenants ayant terminé leur formation. Le lien de génération de votre certificat vous est transmis par e-mail après validation de votre parcours. Pour toute question, contactez{" "}
              <a href="mailto:contact@mgbschool.fr" className="text-[#F07B1D] underline font-semibold">
                contact@mgbschool.fr
              </a>.
            </p>
          </div>
        </div>

        {/* Form */}
        <div
          className="bg-white rounded-xl p-6 md:p-8 shadow-sm mb-8 border border-gray-100"
          data-testid="certificat-form"
        >
          <h1 className="font-heading text-2xl font-bold text-[#003087] mb-1">
            Personnaliser le certificat
          </h1>
          <p className="text-sm text-gray-500 mb-6">
            Les modifications apparaissent en direct sur le certificat ci-dessous.
          </p>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-[#003087] mb-1 uppercase tracking-wider">
                Nom et prénom de l'apprenant
              </label>
              <input
                type="text"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                placeholder="Marie Dupont"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#F07B1D] focus:ring-1 focus:ring-[#F07B1D]"
                data-testid="cert-input-nom"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-[#003087] mb-1 uppercase tracking-wider">
                Formation suivie
              </label>
              <select
                value={formationIdx}
                onChange={(e) => setFormationIdx(parseInt(e.target.value, 10))}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#F07B1D] focus:ring-1 focus:ring-[#F07B1D] bg-white"
                data-testid="cert-input-formation"
              >
                {CERT_FORMATIONS.map((f, i) => (
                  <option key={f.name} value={i}>
                    {f.name} ({f.price} €)
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs font-bold text-[#003087] mb-1 uppercase tracking-wider">
                Date de délivrance
              </label>
              <input
                type="date"
                value={dateISO}
                onChange={(e) => setDateISO(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#F07B1D] focus:ring-1 focus:ring-[#F07B1D]"
                data-testid="cert-input-date"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-[#003087] mb-1 uppercase tracking-wider">
                Résultat
              </label>
              <select
                value={resultat}
                onChange={(e) => setResultat(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#F07B1D] focus:ring-1 focus:ring-[#F07B1D] bg-white"
                data-testid="cert-input-resultat"
              >
                <option value="validee">☑ Formation validée</option>
                <option value="en-cours">☐ En cours</option>
              </select>
            </div>

            <div className="md:col-span-2">
              <label className="block text-xs font-bold text-[#003087] mb-1 uppercase tracking-wider">
                Score quiz (optionnel)
              </label>
              <input
                type="text"
                value={score}
                onChange={(e) => setScore(e.target.value)}
                placeholder="85 / 100"
                className="w-full md:w-1/2 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#F07B1D] focus:ring-1 focus:ring-[#F07B1D]"
                data-testid="cert-input-score"
              />
            </div>
          </div>

          {/* Bouton download (desktop) */}
          <button
            onClick={handleDownload}
            disabled={downloading}
            className="hidden md:flex mt-6 w-full items-center justify-center bg-[#F07B1D] hover:bg-[#D96A0F] disabled:opacity-60 text-white font-bold py-3.5 rounded-lg transition-all"
            data-testid="cert-download-btn"
          >
            {downloading ? "Génération en cours…" : "📥 Télécharger le certificat en PDF"}
          </button>
        </div>

        {/* CERTIFICAT (live preview) */}
        <div className="overflow-x-auto">
          <div
            id="certificat-printable"
            ref={certificateRef}
            data-testid="certificat-preview"
            style={{
              width: "210mm",
              minHeight: "297mm",
              margin: "0 auto",
              backgroundColor: "#FFFFFF",
              border: "6px solid #F07B1D",
              padding: "14px",
              boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
              fontFamily: '"Open Sans", system-ui, sans-serif',
              color: "#1E293B",
              position: "relative",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                border: "1.2px solid #2196F3",
                padding: "0",
                minHeight: "calc(297mm - 40px)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* HEADER bande bleu ciel */}
              <div
                style={{
                  backgroundColor: "#2196F3",
                  height: "110px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                    padding: "12px",
                    borderRadius: "10px",
                    display: "inline-block",
                  }}
                >
                  <img
                    src={LOGO_URL}
                    alt="MGB School"
                    crossOrigin="anonymous"
                    style={{ width: "260px", maxHeight: "80px", objectFit: "contain", display: "block" }}
                  />
                </div>
              </div>
              <div style={{ height: "6px", backgroundColor: "#F07B1D" }}></div>

              {/* TITRE */}
              <div style={{ padding: "32px 40px 12px", textAlign: "center" }}>
                <h2
                  style={{
                    fontSize: "27px",
                    fontWeight: 700,
                    color: "#1A3A6E",
                    margin: 0,
                    letterSpacing: "1px",
                  }}
                >
                  CERTIFICAT DE RÉALISATION
                </h2>
                <div
                  style={{
                    width: "120px",
                    height: "2.5px",
                    backgroundColor: "#F07B1D",
                    margin: "8px auto 12px",
                    borderRadius: "2px",
                  }}
                />
                <p
                  style={{
                    color: "#F07B1D",
                    fontSize: "13px",
                    fontWeight: 700,
                    margin: 0,
                  }}
                >
                  {formation.name}
                </p>
              </div>

              {/* CORPS */}
              <div style={{ padding: "12px 50px 0", textAlign: "center" }}>
                <p style={{ fontSize: "10.5px", color: "#1E293B", margin: 0 }}>
                  MGB School — Organisme de formation professionnelle — certifie que
                </p>
              </div>

              {/* CHAMP NOM */}
              <div style={{ padding: "16px 50px 0" }}>
                <div
                  style={{
                    backgroundColor: "#F5F7FA",
                    border: "1.5px solid #F07B1D",
                    borderRadius: "8px",
                    padding: "14px 18px",
                  }}
                >
                  <p
                    style={{
                      color: "#F07B1D",
                      fontSize: "7.5px",
                      fontWeight: 700,
                      letterSpacing: "1px",
                      margin: "0 0 6px",
                    }}
                  >
                    NOM ET PRÉNOM DE L'APPRENANT(E)
                  </p>
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#1A3A6E",
                      borderBottom: "1.5px dotted #1A3A6E",
                      paddingBottom: "4px",
                      margin: 0,
                      minHeight: "26px",
                    }}
                  >
                    {nom || "—"}
                  </p>
                </div>
              </div>

              {/* TEXTE */}
              <div style={{ padding: "14px 50px 0", textAlign: "center" }}>
                <p style={{ fontSize: "10.5px", color: "#1E293B", margin: 0 }}>
                  a suivi et validé avec succès la formation :
                </p>
              </div>

              {/* ENCADRÉ FORMATION */}
              <div style={{ padding: "10px 50px 0" }}>
                <div
                  style={{
                    backgroundColor: "#2196F3",
                    color: "#FFFFFF",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ margin: 0, fontSize: "12px", fontWeight: 700 }}>
                    {formation.name} · {formation.price} €
                  </p>
                </div>
              </div>

              {/* ZONE DÉTAILS */}
              <div style={{ padding: "12px 50px 0" }}>
                <div
                  style={{
                    backgroundColor: "#F5F7FA",
                    border: "1px solid #E2E8F0",
                    borderLeft: "5px solid #F07B1D",
                    borderRadius: "6px",
                    padding: "12px 16px",
                    fontSize: "9.5px",
                    color: "#1E293B",
                    lineHeight: 1.55,
                  }}
                >
                  <p style={{ margin: "0 0 4px" }}>
                    <strong>Contenu :</strong> {formation.content}
                  </p>
                  <p style={{ margin: "0 0 4px" }}>
                    <strong>Durée :</strong> Formation complète — accès à vie
                  </p>
                  <p style={{ margin: "0 0 4px" }}>
                    <strong>Évaluation :</strong> Quiz · Exercices pratiques · Étude de cas
                  </p>
                  <p style={{ margin: "0 0 4px" }}>
                    <strong>Organisme :</strong> MGB School · SASU · SIRET 999 673 635 00010
                  </p>
                  <p style={{ margin: 0 }}>
                    <strong>Tarif :</strong> {formation.price} € · Paiement unique · Exonération TVA art. 261-4-4° CGI
                  </p>
                </div>
              </div>

              {/* RÉSULTAT */}
              <div style={{ padding: "10px 50px 0" }}>
                <div
                  style={{
                    backgroundColor: "#F5F7FA",
                    border: "1px solid #F07B1D",
                    borderRadius: "6px",
                    padding: "10px 16px",
                    fontSize: "10px",
                    color: "#1E293B",
                  }}
                >
                  <strong>Résultat : </strong>
                  {resultat === "validee" ? "☑" : "☐"} Formation validée &nbsp;&nbsp;
                  {resultat === "en-cours" ? "☑" : "☐"} En cours
                  <span style={{ marginLeft: "16px" }}>
                    Score quiz : <strong>{score || "_______"}</strong> / 100
                  </span>
                </div>
              </div>

              {/* SIGNATURES */}
              <div style={{ padding: "16px 50px 0", display: "flex", gap: "16px", flex: 1 }}>
                <div
                  style={{
                    flex: 1,
                    backgroundColor: "#F5F7FA",
                    border: "1.2px solid #2196F3",
                    borderRadius: "8px",
                    padding: "12px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ fontSize: "9px", color: "#1A3A6E", fontWeight: 700, margin: "0 0 8px" }}>
                    Signature et cachet de l'Organisme
                  </p>
                  <img
                    src={LOGO_URL}
                    alt="MGB School"
                    crossOrigin="anonymous"
                    style={{ width: "130px", backgroundColor: "#FFFFFF", padding: "4px", borderRadius: "4px", margin: "0 auto 10px", display: "block" }}
                  />
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      border: "2.5px solid #F07B1D",
                      borderRadius: "50%",
                      margin: "0 auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        inset: "4px",
                        border: "1px solid #2196F3",
                        borderRadius: "50%",
                      }}
                    />
                    <span
                      style={{
                        color: "#1A3A6E",
                        fontSize: "9px",
                        fontWeight: 700,
                        textAlign: "center",
                        lineHeight: 1.1,
                      }}
                    >
                      MGB<br />SCHOOL
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    flex: 1,
                    backgroundColor: "#F5F7FA",
                    border: "1.2px solid #2196F3",
                    borderRadius: "8px",
                    padding: "12px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ fontSize: "9px", color: "#1A3A6E", fontWeight: 700, margin: "0 0 8px" }}>
                    Date de délivrance
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#1A3A6E",
                      fontWeight: 700,
                      margin: "6px 0 18px",
                      borderBottom: "1.5px dotted #1A3A6E",
                      paddingBottom: "4px",
                    }}
                  >
                    {formatDateFR(dateISO)}
                  </p>
                  <p style={{ fontSize: "9px", color: "#1A3A6E", fontWeight: 700, margin: "0 0 18px" }}>
                    Signature du responsable de formation
                  </p>
                  <div
                    style={{
                      borderBottom: "1.5px dotted #1A3A6E",
                      width: "70%",
                      margin: "0 auto",
                      height: "20px",
                    }}
                  />
                </div>
              </div>

              {/* Spacer */}
              <div style={{ flex: 1 }} />

              {/* PIED DE PAGE */}
              <div>
                <div style={{ height: "3px", backgroundColor: "#F07B1D" }} />
                <div
                  style={{
                    backgroundColor: "#2196F3",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      color: "#FFFFFF",
                      fontSize: "7.5px",
                      margin: 0,
                      lineHeight: 1.4,
                    }}
                  >
                    MGB School · 25 rue de Ponthieu, 75008 Paris · contact@mgbschool.fr · mgbschool.com · 07 58 78 35 74
                  </p>
                </div>
                {/* Mention de droits d'auteur — articles L122-4 et L335-2 du CPI */}
                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                    padding: "6px 12px 8px",
                    textAlign: "center",
                    borderTop: "1px solid #E2E8F0",
                  }}
                >
                  <p
                    style={{
                      color: "#1A3A6E",
                      fontSize: "6.5px",
                      fontWeight: 700,
                      margin: "0 0 2px",
                      lineHeight: 1.3,
                    }}
                  >
                    © 2026 MGB School — Tous droits réservés · Auteure : Maryse GALITA
                  </p>
                  <p
                    style={{
                      color: "#64748B",
                      fontSize: "6px",
                      fontStyle: "italic",
                      margin: 0,
                      lineHeight: 1.3,
                    }}
                  >
                    Toute reproduction, diffusion ou utilisation commerciale est interdite sans autorisation écrite (articles L122-4 et L335-2 du CPI).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bouton fixed mobile */}
      <div
        className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-white border-t border-gray-200 shadow-lg"
        data-testid="cert-mobile-download-bar"
      >
        <button
          onClick={handleDownload}
          disabled={downloading}
          className="w-full bg-[#F07B1D] hover:bg-[#D96A0F] disabled:opacity-60 text-white font-bold rounded-lg transition-all"
          style={{ height: "52px" }}
        >
          {downloading ? "Génération…" : "📥 Télécharger le certificat en PDF"}
        </button>
      </div>
    </div>
  );
};

export default CertificatPage;
